var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-scroll-to-top no-print",class:{'show': _vm.y > 250}})}
var staticRenderFns = []

export { render, staticRenderFns }